"use strict";

exports.__esModule = true;
exports.default = void 0;
var _ssr = require("@restart/ui/ssr");
var _default = exports.default = _ssr.SSRProvider;